import { useState } from 'react';

import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { BootstrapTooltip, TooltipIcon } from './IconTooltip.styles';

export default function IconTooltip({ content, icon }) {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <BootstrapTooltip
      onClose={() => setShowTooltip(false)}
      onOpen={() => setShowTooltip(true)}
      open={showTooltip}
      title={
        <Text
          color="white"
          size="sm"
        >
          {content}
        </Text>
      }
    >
      <TooltipIcon
        aria-label="tooltip-icon"
        onClick={() => setShowTooltip(!showTooltip)}
      >
        {icon ?? (
          <InfoOutlinedIcon
            color="text.tertiary"
            sx={{ fontSize: '16px' }}
          />
        )}
      </TooltipIcon>
    </BootstrapTooltip>
  );
}

IconTooltip.propTypes = {
  content: PropTypes.string,
  icon: PropTypes.node
};

IconTooltip.defaultValue = {
  content: ''
};
